/**
 * <ReportSessionTimesCard> — the three timed blocks of a V1 report (organism, L0.1).
 *
 * "TEMPS CONNECTÉ.E AU LIVE" / "TEMPS D'EXPLICATION" / "TEMPS DE PRODUCTION CHRONOMÉTRÉ", one
 * `<ReportTimeCard>` each, in the legacy order (`LiveReportComponent:1153-1253`). The titles are
 * the legacy copy verbatim — including "connecté.e", which the parent reads as-is today.
 *
 * Glyphs: the legacy PNGs (live / video / chronometer) map to the Lucide vocabulary the DS
 * already carries — signal for the connection, the tutor's board for the explanation, the clock
 * for the timed production. No bundled asset needed.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { type IconName } from "../../atoms/icons/Icon"
import { ReportTimeCard } from "../../molecules/ReportTimeCard"
import { type UILiveSessionReportTimes } from "../../../ports/primary/ui/types"

export type ReportSessionTimesCardProps = {
    times: UILiveSessionReportTimes
    testID?: string
}

const BLOCKS: { key: keyof UILiveSessionReportTimes; title: string; iconName: IconName }[] = [
    { key: "liveConnection", title: "TEMPS CONNECTÉ.E AU LIVE", iconName: "signal" },
    { key: "tutorCall", title: "TEMPS D'EXPLICATION", iconName: "chalkboard-teacher" },
    { key: "production", title: "TEMPS DE PRODUCTION CHRONOMÉTRÉ", iconName: "clock" },
]

export function ReportSessionTimesCard(props: ReportSessionTimesCardProps) {
    const { times, testID } = props

    return (
        <Stack gap="5" testID={testID}>
            {BLOCKS.map((block) => (
                <ReportTimeCard
                    key={block.key}
                    title={block.title}
                    iconName={block.iconName}
                    seconds={times[block.key]}
                />
            ))}
        </Stack>
    )
}
